export function extendAxiosTransformer<T>(
	baseTransformer: T | T[] | undefined,
	extensions: Array<T>
) {
	return ([] as Array<T>).concat(baseTransformer ?? [], extensions);
}
